// Variant selection and quantity steppers for the bar & wine collection cards.
if (!customElements.get('kazari-collection-buy')) {
  customElements.define('kazari-collection-buy', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleSelection);
      this.addEventListener('click', this.handleStep);
      this.updateVariant();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.handleSelection);
      this.removeEventListener('click', this.handleStep);
    }
    handleSelection = (event) => {
      if (event.target.matches('[data-kazari-variant-select]')) this.updateVariant();
    };
    updateVariant() {
      const picker = this.querySelector('[data-kazari-variant-select]');
      const variantInput = this.querySelector('[data-kazari-variant-input]');
      const button = this.querySelector('button[name="add"]');
      if (!variantInput || !button) return;
      const selected = picker?.selectedOptions[0];
      const id = picker ? picker.value : this.dataset.singleVariantId;
      const available = picker ? Boolean(id) && selected?.dataset.available === 'true' : this.dataset.singleAvailable === 'true';
      variantInput.value = id || '';
      variantInput.disabled = !available;
      button.disabled = !available;
    }
    handleStep = (event) => {
      const target = event.target.closest('[data-kazari-step]');
      if (!target || !this.contains(target)) return;
      const input = this.querySelector('input[name="quantity"]');
      if (!input) return;
      const step = Number(target.dataset.kazariStep);
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      const current = Math.max(min, Number(input.value) || min);
      input.value = String(Math.max(min, Math.min(max, current + step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
  });
}
